export const DESKTOP_GAME_SOURCE_CONTRACT = {
  sourceRelease: "0.0.81",
  appVersion: "1.0.0",
  productLanguage: "en",
  artboard: {
    width: 1600,
    height: 900,
  },
  background: {
    id: "t1",
    label: "Rectangular tunnel",
  },
  lastOperationLabel: "Last operation:",
  status: {
    title: "Status",
    rows: ["HTTP bridge", "Blender server"],
  },
  controls: ["Start", "Stop", "Open Blender", "Add add-on", "Share to socials"],
  runtimeBindings: [
    { id: "lblBtnStart", key: "btnStart" },
    { id: "btnStop", key: "btnStop" },
    { id: "btnOpenBlender", key: "btnOpenBlender" },
    { id: "btnExportAddon", key: "btnExportAddon" },
    { id: "btnShareSocial", key: "btnShareSocial" },
  ],
  history: {
    title: "Bridge history",
    actions: ["Clear", "Copy"],
  },
  footer: {
    version: "Blender Bridge v1.0.0",
    ports: "Ports: bridge 8765 • Blender 9000",
  },
  motion: {
    automaticForward: "worldOffset += speed * dt",
    jumpCodes: ["ArrowUp", "KeyW"],
    lateralCodes: ["ArrowLeft", "ArrowRight", "KeyA", "KeyD"],
  },
  physics: {
    cubeSize: 0.86,
    cubeRadius: 0.43,
    worldSpeed: 2.12,
    brakeMultiplier: 0.42,
    sideStep: 0.86,
    lateralLimit: 5.54,
    maxJumps: 3,
    rollDuration: 0.32,
    gravity: 11.2,
    softFallGravity: 4.4,
    jumpImpulse: 6.9,
    groundY: -3.17,
    cubeZ: -3.05,
  },
  chrome: {
    appPadding: {
      top: 18,
      right: 18,
      bottom: 14,
      left: 18,
    },
    gapPx: 14,
    sysbarHeightPx: 54,
    headerMinHeightPx: 74,
    windowButtonPx: 32,
    contentColumns: "clamp(280px, 30vw, 360px) 1fr",
    contentColumnMinPx: 280,
    contentColumnFraction: 0.3,
    contentColumnMaxPx: 360,
    artboardContentColumns: "clamp(280px, calc(var(--uses-desktop-artboard-width) * 0.3), 360px) 1fr",
    controlMinHeightPx: 52,
  },
  mobileDetail: {
    scale: 0.82,
    controlsCenterX: 198,
    tunnelCenterX: 800,
    controlsAnchorPx: -162.36,
    panTravelPx: -493.64,
  },
  tunnelGeometry: {
    owner: "BB_WORLD3D",
    builder: "buildSquareTunnel",
    cell: 0.82,
    halfWidth: 6.4,
    halfHeight: 3.6,
    zFront: 10,
    zBack: -920,
    ringCount: 1135,
    xGridCount: 16,
    yGridCount: 9,
    longitudinalCount: 50,
    lineOpacity: 0.105,
    camera: {
      fov: 54,
      near: 0.02,
      far: 250,
      z: 6.2,
      lookAtZ: -22,
    },
    fogDensity: 0.019,
    endVoidScale: 0.72,
    endVoidZ: -120,
    worldOffsetWrap: "worldRoot.position.z = worldOffset % CELL",
  },
} as const;

export const READY_VIDEO_SOURCE_CONTRACT = {
  src: "/assets/video/bb-logo.mp4",
  aspectRatio: "1 / 1",
  preload: "metadata",
  controls: false,
  playsInline: true,
  autoplay: true,
  muted: true,
  loop: true,
} as const;

export const TRAILER_VIDEO_SOURCE_CONTRACT = {
  src: "/assets/video/bb-trailer-final.mp4",
  embeddedSrc: "/assets/video/bb-trailer-web-960.mp4",
  embeddedWidth: 960,
  embeddedHeight: 540,
  embeddedDerivation: "2K master → area-resampled 960×540, H.264 CRF 17, AAC copied, faststart",
  source: "Design_System_Laboratory/Video2_Renders/video_trailer_official_2k_autoexec_20260604_213649/BB_TRAILER_FINAL_1080.mp4",
  aspectRatio: "16 / 9",
  width: 1920,
  height: 1080,
  durationSeconds: 89,
  audio: "AAC stereo 48 kHz",
  preload: "metadata",
  controls: false,
  playsInline: true,
  autoplay: true,
  muted: true,
  loop: true,
} as const;

export const SITE_SELF_SOURCE_CONTRACT = {
  host: "blenderbridge.com",
  mode: "adopt-existing-live-dom",
  rendererCount: 1,
  clonePolicy: "forbidden",
  releasePolicy: "restore-original-parent-and-order",
} as const;

export const USES_SOURCE_CONTRACT = {
  desktop: DESKTOP_GAME_SOURCE_CONTRACT,
  readyVideo: READY_VIDEO_SOURCE_CONTRACT,
  site: SITE_SELF_SOURCE_CONTRACT,
  privateDataPolicy: "neutral-staged-data-only",
} as const;
